import { render, staticRenderFns } from "./Export.vue?vue&type=template&id=27a80a20&scoped=true"
import script from "./Export.vue?vue&type=script&lang=js"
export * from "./Export.vue?vue&type=script&lang=js"
import style0 from "./Export.vue?vue&type=style&index=0&id=27a80a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a80a20",
  null
  
)

export default component.exports